<template>
    <div class="embed">
        <iframe
            v-if="url"
            :src="url"
            loading="lazy"
            width="100%"
            :height="height"
            frameborder="0"
            allowfullscreen="true"
            referrerpolicy="origin"
            :sandbox="sandbox"
        />
    </div>
</template>

<script setup>
const props = defineProps({
    url: {
        type: String,
        required: true,
        default: ''
    },
    height: {
        type: String,
        required: false,
        default: 'auto'
    }
});

const requestUrl = useRequestURL();

// allow-same-origin is needed for embeds that use their own storage/cookies, but combined with
// allow-scripts a same-origin embed could remove its own sandbox, so only grant it cross-origin.
const sandbox = computed(() => {
    const flags = 'allow-forms allow-modals allow-popups allow-scripts allow-top-navigation-by-user-activation';

    try {
        const embedOrigin = new URL(props.url, requestUrl.origin).origin;

        return embedOrigin !== requestUrl.origin ? `${flags} allow-same-origin` : flags;
    } catch {
        return flags;
    }
});
</script>
